<template>
    <div v-if="currentPage && totalPages" class="pagination">
        <svg-icon
            name="double_arrow_left"
            class="pagination__arrow"
            :class="{ 'pagination__arrow--disabled': currentPage === 1 }"
            @click="goToPreviousPage"
        />
        <div
            v-for="pageNumber in pageNumbers"
            :key="pageNumber"
            class="pagination__page"
            :class="{ 'pagination__current-page': currentPage === pageNumber }"
            @click="goToPage(pageNumber)"
        >
            {{ pageNumber }}
        </div>
        <svg-icon
            name="double_arrow_right"
            class="pagination__arrow"
            :class="{ 'pagination__arrow--disabled': currentPage === totalPages }"
            @click="goToNextPage"
        />
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
    },
    computed: {
        pageNumbers() {
            if (!this.currentPage || !this.totalPages) {
                this.$sentry.captureMessage('Pagination component is missing currentPage or totalPages props', 'error');

                return [];
            }

            const { currentPage, totalPages } = this;
            const maxRange = 3;
            const generateSequence = (start, end) => Array.from({ length: end - start + 1 }, (_, i) => i + start);

            if (totalPages <= maxRange) {
                return generateSequence(1, totalPages);
            }

            if (currentPage === 1) {
                return generateSequence(1, maxRange);
            } else if (currentPage === totalPages) {
                return generateSequence(totalPages - 2, totalPages);
            } else {
                return generateSequence(currentPage - 1, currentPage + 1);
            }
        },
    },
    methods: {
        goToPreviousPage() {
            if (this.currentPage === 1) {
                return;
            }

            this.$emit('page-change', this.currentPage - 1);
        },
        goToNextPage() {
            if (this.currentPage === this.totalPages) {
                return;
            }

            this.$emit('page-change', this.currentPage + 1);
        },
        goToPage(pageNumber) {
            if (this.currentPage === pageNumber) {
                return;
            }

            this.$emit('page-change', pageNumber);
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.pagination {
    display: flex;
    align-items: center;
    gap: 40px;

    &__page {
        cursor: pointer;
    }

    &__current-page {
        font-weight: bold;
        cursor: default;
    }

    &__arrow {
        fill: $primary;
        cursor: pointer;

        &--disabled {
            fill: $gray;
            cursor: not-allowed;
        }
    }
}
</style>
